import {
	Directive,
	ElementRef,
	EventEmitter,
	NgModule,
	NgZone,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';

@Directive({
	standalone: false,
	selector: '[sizeChange]',
})
export class SizeChangeDirective<T extends HTMLElement> implements OnInit, OnDestroy {
	@Output('sizeChange')
	public sizeChange$$ = new EventEmitter<T>();

	private resizeObserver?: ResizeObserver;

	constructor(
		private readonly elementRef: ElementRef<T>,
		private readonly ngZone: NgZone
	) {}

	ngOnInit(): void {
		this.resizeObserver = new ResizeObserver(() => {
			this.ngZone.run(() => {
				this.sizeChange$$.emit(this.elementRef.nativeElement);
			});
		});

		this.resizeObserver.observe(this.elementRef.nativeElement);
	}

	ngOnDestroy(): void {
		this.resizeObserver?.disconnect();
	}
}

@NgModule({
	declarations: [SizeChangeDirective],
	imports: [],
	exports: [SizeChangeDirective],
})
export class SizeChangeModule {}
